// deps
import React, { memo } from "react";

// constants
import { FOOTER_TEXTS } from "@dineout-payment-success-ui/constants/Footer";

// styles
import { AssistanceLinkHelp } from "./styles";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { PAYMENT_SUCCESS_FOOTER } from "@swiggy-private/payment-test-ids";

// types
import { IAssistanceLink } from "@dineout-payment-success-ui/interfaces";

const AssistanceLink: React.FC<IAssistanceLink> = ({ viewHelpClickHandler }) => {
    return (
        <>
            <Text
                variant="V2.body3.neutral.bold"
                color="text_Med_Emphasis"
                data-testid={PAYMENT_SUCCESS_FOOTER.VIEW_HELP}
            >
                {FOOTER_TEXTS.PAYMENT_NEED_HELP}
                <AssistanceLinkHelp onClick={viewHelpClickHandler} data-testid={PAYMENT_SUCCESS_FOOTER.HELP_BTN}>
                    {FOOTER_TEXTS.PAYMENT_VIEW_HELP}
                </AssistanceLinkHelp>
            </Text>
        </>
    );
};

export default memo(AssistanceLink);
